import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo } from "react";

interface ZoomExtentToolProps {
    zoomToExtent: Function
};

const ZoomExtentTool = ({ zoomToExtent }: ZoomExtentToolProps) => {
    return (
        <div className="mapboxgl-ctrl-top-left" style={{top:'65px', left:'0'}}>
          <div className="mapboxgl-ctrl mapboxgl-ctrl-group">
            <button
              className="mapboxgl-ctrl-icon mapboxgl-ctrl-fullscreen"
              title="Zoom to extent"
              onClick={() => zoomToExtent()}
            >
                <FontAwesomeIcon icon={faExpand} />
            </button>
          </div>
        </div>
    );
}

export default memo(ZoomExtentTool);